import Glide from "@glidejs/glide";

export default (container: HTMLElement) => {
  const { dataLayer } = window;
  const initialHashExists = window.location.hash.startsWith("#slide-");
  let hasUserInteracted = false;

  const setEqualHeight = () => {
    const slides = document.querySelectorAll<HTMLElement>(".glide__content");
    let maxHeight = 0;

    slides.forEach((slide) => {
      const slideHeight = slide.offsetHeight;
      if (slideHeight > maxHeight) {
        maxHeight = slideHeight;
      }
    });

    slides.forEach((slide) => {
      // eslint-disable-next-line no-param-reassign
      slide.style.height = `${maxHeight}px`;
    });
  };

  const updateHash = (index: number) => {
    window.history.replaceState(null, "", `#slide-${index + 1}`);
  };

  const getSlideIndexFromHash = (): number => {
    const { hash } = window.location;
    if (hash) {
      const index = parseInt(hash.replace("#slide-", ""), 10) - 1;
      return Number.isNaN(index) ? 0 : index;
    }
    return 0;
  };

  const handleVideoPlayback = (activeIndex: number) => {
    const fullSlides = container.querySelectorAll(".glide__slide");
    fullSlides.forEach((slideVideo, index) => {
      const video = slideVideo.querySelector<HTMLVideoElement>("video");
      if (video) {
        if (index === activeIndex) {
          video.play();
        } else {
          video.currentTime = 0;
        }
      }
    });
  };

  const handleAnalytics = () => {
    const activeSlide = container.querySelector<HTMLElement>(".glide__slide--active");
    if (activeSlide) {
      const analyticsData = activeSlide.dataset.analyticsView;
      if (analyticsData) {
        dataLayer.push(JSON.parse(analyticsData));
      }
    }
  };

  const isMobileViewport = () => window.innerWidth <= 991;

  const slides = container.querySelectorAll(".glide__content");

  if (isMobileViewport() && slides.length > 1) {
    const glide = new Glide(container, {
      type: "carousel",
      gap: 16,
      peek: 48,
      startAt: getSlideIndexFromHash(),
    });

    glide.on("move.after", () => {
      if (hasUserInteracted || initialHashExists) {
        updateHash(glide.index);
      } else {
        hasUserInteracted = true;
      }

      handleVideoPlayback(glide.index);
    });

    glide.on("run.after", handleAnalytics);

    glide.mount();

    setEqualHeight();

    window.addEventListener("resize", () => {
      if (isMobileViewport()) {
        setEqualHeight();
      } else {
        slides.forEach((slide) => {
          const slideElement = slide as HTMLElement;
          slideElement.style.height = "";
        });
      }
    });

    window.addEventListener("hashchange", () => {
      const newIndex = getSlideIndexFromHash();
      if (glide.index !== newIndex) {
        glide.go(`=${newIndex}`);
      }

      container.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });

    // 🔥 První načtení s hashem: ručně spustíme video, analytiku a scroll
    if (initialHashExists) {
      const initialIndex = getSlideIndexFromHash();

      // Glide někdy potřebuje trošku počkat po mountu, než se index opravdu nastaví
      setTimeout(() => {
        handleVideoPlayback(initialIndex);
        handleAnalytics();

        container.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  } else if (slides.length <= 1) {
    const glideElement = container.querySelector(".glide");
    if (glideElement) glideElement.classList.add("p-8");

    const bulletsElement = container.querySelector(".glide__bullets");
    if (bulletsElement) bulletsElement.classList.add("hidden");

    const arrowsElement = container.querySelector(".glide__arrows");
    if (arrowsElement) arrowsElement.classList.add("hidden");

    container.classList.add("!mb-4");
  }
};
